// sapi-admin/src/pages/DeliveryTracking.jsx
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import DeliveryDashboard from '../components/DeliveryDashboard';
import { Truck } from 'lucide-react';

export default function DeliveryTracking() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simuler le chargement ou charger les données
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 400, gap: 16 }}>
        <div style={{ width: 44, height: 44, borderRadius: '50%', border: '3px solid rgba(245,158,11,.3)', borderTopColor: '#f59e0b', animation: 'spin .8s linear infinite' }} />
        <p style={{ color: '#64748b', fontSize: 13, fontWeight: 600 }}>Loading Delivery Tracking…</p>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    );
  }

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6 pb-8">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-widest text-amber-400/80 font-medium mb-1">
            📦 Delivery Management
          </p>
          <h1 className="text-2xl md:text-3xl font-bold text-white flex items-center gap-3">
            <Truck size={28} className="text-amber-400" />
            Delivery Tracking
          </h1>
          <p className="text-sm text-slate-400 mt-1">
            Monitor orders currently being delivered and manage delays
          </p>
        </div>
      </div>
      
      <DeliveryDashboard />
    </motion.div>
  );
}